import { render, staticRenderFns } from "./UploadFileBucket.vue?vue&type=template&id=f6980542&scoped=true"
import script from "./UploadFileBucket.vue?vue&type=script&lang=js"
export * from "./UploadFileBucket.vue?vue&type=script&lang=js"
import style0 from "./UploadFileBucket.vue?vue&type=style&index=0&id=f6980542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6980542",
  null
  
)

export default component.exports